<script setup lang="ts">
const props = defineProps<{
	token?: string
	email?: string
}>()

const form = useForm({
	method: 'POST',
	url: route('password.update'),
	fields: {
		token: props.token,
		email: props.email,
		password: '',
		password_confirmation: '',
	},
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/security.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<ui-card-content>
		<ui-form @submit.prevent="form.submit">
			<ui-form-item>
				<ui-label for="email">
					{{ t('validation.attributes.email') }}
				</ui-label>
				<ui-input
					id="email"
					v-model="form.fields.email"
					required
					autocapitalize="off"
					autocomplete="username"
					autocorrect="off"
					type="email"
				/>
				<ui-form-error :message="form.errors.email" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="password">
					{{ t('validation.attributes.password') }}
				</ui-label>
				<ui-input
					id="password"
					v-model="form.fields.password"
					required
					autofocus
					autocapitalize="off"
					autocomplete="new-password"
					autocorrect="off"
					type="password"
				/>
				<ui-form-error :message="form.errors.password" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="password_confirmation">
					{{ t('validation.attributes.password_confirmation') }}
				</ui-label>
				<ui-input
					id="password_confirmation"
					v-model="form.fields.password_confirmation"
					required
					autocapitalize="off"
					autocomplete="new-password"
					autocorrect="off"
					type="password"
				/>
				<ui-form-error :message="form.errors.password_confirmation" />
			</ui-form-item>

			<ui-button type="submit" :loading="form.processing">
				{{ t('app.buttons.reset_password') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</ui-card-content>

	<ui-card-footer :class="cn('rounded-b-none sm:rounded-b-xl', $attrs.class ?? '')">
		<div class="flex w-full items-center justify-center gap-1 text-sm text-gray-500">
			<span>{{ t('app.remember_your_password_again') }}</span>
			<ui-link :href="route('login')">
				{{ t('app.buttons.sign_in') }}
			</ui-link>
		</div>
	</ui-card-footer>
</template>
